import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const basePath = '/dnfministry';

  const navLinks = [
    { name: 'Home', path: `${basePath}` },
    { name: 'About', path: `${basePath}/about` },
    { name: 'Services', path: `${basePath}/services` },
    { name: 'Gallery', path: `${basePath}/gallery` },
    { name: 'FAQ', path: `${basePath}/faq` },
    { name: 'Contact', path: `${basePath}/contact` },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        backgroundColor: 'rgba(26, 26, 26, 0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(184, 134, 11, 0.2)'
      }}
    >
      <div style={{ maxWidth: '80rem', margin: '0 auto', padding: '0 1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '5rem' }}>
          {/* Logo */}
          <Link to={basePath} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textDecoration: 'none' }}>
            <span className="font-script" style={{ fontSize: '1.75rem', color: '#B8860B' }}>
              Drip N Fiyah
            </span>
            <span style={{ fontSize: '0.65rem', letterSpacing: '0.3em', color: 'rgba(245,245,220,0.6)', textTransform: 'uppercase' }}>
              Ministry
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: '2rem' }} className="hidden md:flex">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                style={{
                  fontSize: '0.8rem',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  transition: 'color 0.3s',
                  color: isActive(link.path) ? '#B8860B' : 'rgba(245,245,220,0.8)'
                }}
                onMouseOver={(e) => e.target.style.color = '#d4a828'}
                onMouseOut={(e) => e.target.style.color = isActive(link.path) ? '#B8860B' : 'rgba(245,245,220,0.8)'}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to={`${basePath}/booking`}
              className="btn-gold"
              style={{ fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none' }}
              data-testid="book-now-btn"
            >
              Book Now
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            style={{ color: '#F5F5DC', padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer' }}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav 
            className="md:hidden animate-fade-in"
            style={{ 
              padding: '1rem 0', 
              borderTop: '1px solid rgba(184, 134, 11, 0.2)',
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem'
            }}
          >
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                style={{
                  fontSize: '0.875rem',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  padding: '0.5rem 0',
                  color: isActive(link.path) ? '#B8860B' : 'rgba(245,245,220,0.8)'
                }}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to={`${basePath}/booking`}
              onClick={() => setIsMenuOpen(false)}
              className="btn-gold"
              style={{ fontSize: '0.875rem', letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none', textAlign: 'center', marginTop: '1rem' }}
            >
              Book Now
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
